<template>
  <div class="filter-status btnHover">
    <span class="el-dropdown-link">
      <i class="icon iconfont iconicon_all_read"></i>全部已读
    </span>
  </div>
</template>
<script>
export default {
  data() {
    return {

    }
  },
  methods: {
  }
}
</script>
